import { useState } from 'react';

import { Button } from '@/design-system';

import { domainsCopy } from '../copy';

/**
 * Kopieert de instructie bij een DNS-record, met het record erin, zodat je die kunt
 * doorsturen naar wie je website beheert. Zegt na de klik wat er gebeurde: een knop
 * die stil faalt, laat iemand een lege mail versturen.
 *
 * Hetzelfde gedrag als de kopieerknop onder Koppelingen; die staat in een andere
 * feature, dus deze houdt het binnen Instellingen.
 */
export function CopyInstructionButton({ text }: { text: string }) {
    const [result, setResult] = useState<'copied' | 'failed' | null>(null);

    return (
        <div className="mt-[8px] flex flex-wrap items-center gap-2">
            <Button
                variant="outline"
                size="xs"
                icon="copy"
                onClick={() => {
                    void copyToClipboard(text).then((ok) => setResult(ok ? 'copied' : 'failed'));
                }}
            >
                {domainsCopy.copyInstruction}
            </Button>
            <span role="status" className="text-[12px] leading-[1.4] text-[var(--accent-dark)]">
                {result === 'copied' ? domainsCopy.copied : null}
            </span>
            {result === 'failed' ? (
                <span role="alert" className="text-[12px] leading-[1.4] text-[var(--warn-text)]">
                    {domainsCopy.copyFailed}
                </span>
            ) : null}
        </div>
    );
}

/** `true` als het klembord de tekst aannam. */
async function copyToClipboard(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);

        return true;
    } catch {
        return false;
    }
}
